const detector = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  if (userAgent.indexOf('android') !== -1) {
    return 'android';
  } else if (userAgent.indexOf('iphone') !== -1) {
    return 'ios';
  } else {
    return 'pc';
  }
};

export default detector;
